import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { map, switchMap } from 'rxjs';
import { getFullPathFromUrlSegments } from '../../lib/get-full-path';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';
import { GrowthBookService } from '../../services/growth-book.service';
import { LanguageService } from '../../services/language.service';
import { WebsiteChromeService } from '../website-chrome.service';

export const isArticleGuard: CanMatchFn = (a, state) => {
  const storyblokService = inject(PICFLOW_STORYBLOK);
  const growthBookService = inject(GrowthBookService);
  const languageService = inject(LanguageService);
  inject(WebsiteChromeService).prefetch();

  return growthBookService.load().pipe(
    switchMap(() => {
      const path = getFullPathFromUrlSegments(state, true, languageService.currentLanguage()).join('/') || 'home';

      return storyblokService.getStory(path).pipe(
        map(resp => {
          if (!resp || !resp.story) {
            return false; // 404 pages should always use the page component
          }
          return resp.story.content.component === 'article';
        })
      );
    })
  );
};
